import React from 'react';
import Draggable from 'react-draggable';
import cn from 'classnames';
import { message, Row, Tooltip } from 'antd';
import LocaleReceiver from 'antd/es/locale-provider/LocaleReceiver';
import { ConfigConsumer, ConfigConsumerEProps } from '../config-provider';
import defaultLocale from '../locale/default';
import Icon from '../icon';
import "@whalecloud/fdx-theme-fdx/Imageviewer.less";

// 加法
const accAdd = (arg1, arg2) => {
  let r1;
  let r2;
  let newArg1;
  let newArg2;
  try {
    r1 = arg1.toString().split(".")[1].length;
  } catch (e) {
    r1 = 0;
  }
  try {
    r2 = arg2.toString().split(".")[1].length;
  } catch (e) {
    r2 = 0;
  }
  const c = Math.abs(r1 - r2);
  const m = 10 ** Math.max(r1, r2);
  if (c > 0) {
    const cm = 10 ** c;
    if (r1 > r2) {
      newArg1 = Number(arg1.toString().replace(".", ""));
      newArg2 = Number(arg2.toString().replace(".", "")) * cm;
    } else {
      newArg1 = Number(arg1.toString().replace(".", "")) * cm;
      newArg2 = Number(arg2.toString().replace(".", ""));
    }
  } else {
    newArg1 = Number(arg1.toString().replace(".", ""));
    newArg2 = Number(arg2.toString().replace(".", ""));
  }
  return (newArg1 + newArg2) / m;
};

// 减法
const accSub = (arg1, arg2) => {
  let r1;
  let r2;
  try {
    r1 = arg1.toString().split(".")[1].length;
  } catch (e) {
    r1 = 0;
  }
  try {
    r2 = arg2.toString().split(".")[1].length;
  } catch (e) {
    r2 = 0;
  }
  const m = 10 ** Math.max(r1, r2);
  // 动态控制精度长度
  const n = r1 >= r2 ? r1 : r2;
  return ((arg1 * m - arg2 * m) / m).toFixed(n);
};

interface IOProps {
  data: string[];
  onClose: any;
  shadeStyle: any;
  imageStyle: any;
  wrapperStyle: any;
  innerStyle: any;
  scale: any;
  visible: boolean;
  index: number;
}

interface IOState {
  index: any
  scale: any
  defaultPosition: any
}

interface ImageViewLocale {
  previousOne: string;
  nextOne: string;
  zoomIn: string;
  zoomOut: string;
}

class Imageviewer extends React.Component<IOProps, IOState> {
  static defaultProps = {
    data: [],
    onClose: () => {
    },
    shadeStyle: {},
    imageStyle: {},
    wrapperStyle: {},
    innerStyle: {},
    scale: 1,
    visible: false,
  };

  constructor(props) {
    super(props);
    this.state = {
      scale: 1,
      defaultPosition: null,
      index: 0,
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      index: nextProps.index,
    });
  }

  prev = () => {
    const { data = [] } = this.props;
    const { index } = this.state;
    if (index === 0 && data.length > 0) {
      return false;
    }
    if (index > 0 && data.length > 0) {
      this.setState({
        index: index - 1,
      });
    }
    this.backPosition();
  };

  next = () => {
    const { data = [] } = this.props;
    const { index } = this.state;
    if (index === data.length - 1 && data.length > 0) {
      return false;
    }
    if (index < data.length - 1 && data.length > 0) {
      this.setState({
        index: index + 1,
      });
    }
    this.backPosition();
  };

  backPosition = () => {
    setTimeout(() => {
      this.setState({ scale: 1 });
      this.setState({ defaultPosition: { x: 0, y: 0 } });
    }, 500);
  };

  // 缩小
  onToOut = () => {
    const { scale } = this.state;
    if (scale > 0.2) {
      this.setState({ scale: accSub(scale, 0.2) });
    } else {
      message.warning("已缩小到最小级别");
    }
  };

  // 放大
  onToIn = () => {
    const { scale } = this.state;
    if (scale < 3) {
      this.setState({ scale: accAdd(scale, 0.2) });
    } else {
      message.warning("已放大到最大级别");
    }
  };

  handleStart = () => {
    this.setState({ defaultPosition: null });
  };

  handleClose = () => {
    const {
      onClose = () => {
      },
    } = this.props;
    this.setState({
      scale: 1,
    });
    onClose();
  };

  render() {
    const {
      data = [],
      shadeStyle,
      imageStyle,
      visible,
    } = this.props;
    const { scale, defaultPosition, index } = this.state;

    return (
      <ConfigConsumer>
        {({}: ConfigConsumerEProps) => {
          return (
            <LocaleReceiver componentName="ImageViewer" defaultLocale={defaultLocale.ImageViewer}>
              {(locale: ImageViewLocale) => {
                return (
                  <div className="imageviewer" style={{ display: `${visible ? "block" : "none"}` }}>
                    <div className="shadeWrapper" style={{ ...shadeStyle }}>
                      <div className="inner">
                        <Draggable
                          defaultPosition={{ x: 0, y: 0 }}
                          position={defaultPosition}
                          scale={1}
                          onStart={this.handleStart}
                        >
                          <span>
                            <div
                              className={cn({ "imageWrapper": true, "hide": false })}
                              style={{ transform: `scale(${scale})` }}
                            >
                              <img
                                className={"image"}
                                id="TargetImage"
                                src={data[index]}
                                alt={data[index]}
                                style={{ width: "100%", ...imageStyle }}
                              />
                            </div>
                          </span>
                        </Draggable>
                      </div>

                      {/* 操作栏 */}
                      <Row type="flex" className="operateTool">
                        <Tooltip title={locale.previousOne}>
                          <div onClick={this.prev}><Icon type="arrow-left" /></div>
                        </Tooltip>
                        <Tooltip title={locale.nextOne}>
                          <div onClick={this.next}><Icon type="arrow-right" /></div>
                        </Tooltip>
                        <Tooltip title={locale.zoomIn}>
                          <div onClick={this.onToIn}><Icon type="plus" /></div>
                        </Tooltip>
                        <Tooltip title={locale.zoomOut}>
                          <div onClick={this.onToOut}><Icon type="minus" /></div>
                        </Tooltip>
                      </Row>
                      {/* 关闭按钮 */}
                      <div className="closeBtnWrapper" onClick={this.handleClose}>
                        <Icon type="close" style={{ fontSize: "24px" }} />
                      </div>
                    </div>
                  </div>
                )
              }}
            </LocaleReceiver>
          )
        }}
      </ConfigConsumer>
    );
  }
};

export default Imageviewer;



// WEBPACK FOOTER //
// ./src/components/image-viewer/Imageviewer.tsx